import type { IntroSplashSpec } from "@slot/game-shell";

/**
 * The branded intro splash: three cards, each an icon from `intro/introIcons` (the export's merge, multiplied grid and
 * FS packets) with its words in `game.<locale>.json` under `info.intro.cardN.*` (the fallbacks mirror the English).
 * PLACEHOLDER: the volatility is not settled, but the shell's splash always draws its pips — the middle rating stands
 * in until the math fixes it (an open item: a player reads it).
 */
export const INTRO_SPLASH_SPEC: IntroSplashSpec = {
  volatilityRating: 3,
  headlineBadgeAssetPath: null,
  cards: [
    {
      icon: { sheet: "intro/introIcons", frame: "merge" },
      titleKey: "info.intro.card1.title",
      titleFallback: "MERGE",
      bodyKey: "info.intro.card1.body",
      bodyFallback: "Winning clusters merge into fewer, higher symbols that can win again.",
    },
    {
      icon: { sheet: "intro/introIcons", frame: "multipliers" },
      titleKey: "info.intro.card2.title",
      titleFallback: "CELL MULTIPLIERS",
      bodyKey: "info.intro.card2.body",
      bodyFallback: "Every winning cell gains a multiplier that grows with each win.",
    },
    {
      icon: { sheet: "intro/introIcons", frame: "free_spins" },
      titleKey: "info.intro.card3.title",
      titleFallback: "FREE SPINS",
      bodyKey: "info.intro.card3.body",
      bodyFallback: "Land enough FS symbols, or merge your way to them, to trigger free spins.",
    },
  ],
};
